const FACILITY_ADMIN = 'facilityAdmin';
const LOCATION_ADMIN = 'locationAdmin';
const LAB_ADMIN = 'labAdmin';
const LAB_USER = 'labUser';
const SUPER_ADMIN = 'superAdmin';
const CRM_ADMIN = 'crm';
const BILLING = 'billing';
const STAR = 'star';

export {
    FACILITY_ADMIN,
    LOCATION_ADMIN,
    LAB_ADMIN,
    LAB_USER,
    SUPER_ADMIN,
    STAR,
    CRM_ADMIN,
    BILLING
};